import { Component, input, signal, OnInit } from '@angular/core';

import { LucideIconComponent } from '../../lucide-icon/lucide-icon.component';

@Component({
  selector: 'app-form-card',
  standalone: true,
  imports: [LucideIconComponent],
  templateUrl: './form-card.component.html',
})
export class FormCardComponent implements OnInit {
  title = input.required<string>();
  icon = input<string>();
  collapsible = input<boolean>(false);
  defaultCollapsed = input<boolean>(false);

  // Internal state for collapse
  protected isCollapsed = signal(false);

  ngOnInit() {
    this.isCollapsed.set(this.defaultCollapsed());
  }

  protected toggleCollapse(): void {
    if (this.collapsible()) {
      this.isCollapsed.update((val) => !val);
    }
  }
}
